<template>
   <b-modal hide-header-close size="sm" v-model="warningZone" centered ok-only ok-title="Yes">Hey {{user.firstname}}, are you still there? </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "AutoLogout",
  computed: {
    ...mapGetters(["window", "user"]),
  },
  data() {
    return {
      events: ["click", "mousemove", "mousedown", "scroll", "keypress", "load"],
      warningTimer: null,
      logoutTimer: null,
      warningZone: false,
    };
  },
  mounted() {
    this.events.forEach(function (event) {
      window.addEventListener(event, this.resetTimer);
    }, this);
    this.setTimers();
  },
  destroyed() {
    this.events.forEach(function (event) {
      window.removeEventListener(event, this.resetTimer);
    }, this);
    this.resetTimer();
  },
  methods: {
    setTimers() {
      this.warningTimer = setTimeout(this.warningMessage, 25 * 60 * 1000); // 25 mins * 60 * 1000
      this.logoutTimer = setTimeout(this.logoutUser, 30 * 60 * 1000); // 30 mins
      this.warningZone = false;
    },
    warningMessage() {
      this.warningZone = true;
    },
    logoutUser() {
      this.$router.push({ path: "/logout" });
    },
    resetTimer() {
      clearTimeout(this.warningTimer);
      clearTimeout(this.logoutTimer);
      this.setTimers();
    },
  },
};
</script>

<style>
</style>